import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Cafe } from 'src/assets/images/resort/facility/cafe.svg';
import { ReactComponent as Clothes } from 'src/assets/images/resort/facility/clothes.svg';
import { ReactComponent as Hospital } from 'src/assets/images/resort/facility/hospital.svg';
import { ReactComponent as Restaurant } from 'src/assets/images/resort/facility/restaurant.svg';
import { ReactComponent as School } from 'src/assets/images/resort/facility/school.svg';
import { FacilityId } from 'src/models/resort/Construction';

interface FacilityIconProps {
  facilityId: FacilityId;
  iconSize: number;
}

export const FacilityIcon: React.FC<FacilityIconProps> = ({ facilityId, iconSize }) => {
  const { t } = useTranslation('resort');
  switch (facilityId) {
    case 0:
      return <School role="img" width={iconSize} height={iconSize} aria-label={t('facility_0')} />;
    case 1:
      return (
        <Hospital role="img" width={iconSize} height={iconSize} aria-label={t('facility_1')} />
      );
    case 2:
      return (
        <Restaurant role="img" width={iconSize} height={iconSize} aria-label={t('facility_2')} />
      );
    case 3:
      return <Cafe role="img" width={iconSize} height={iconSize} aria-label={t('facility_3')} />;
    case 4:
      return <Clothes role="img" width={iconSize} height={iconSize} aria-label={t('facility_4')} />;
    default:
      return null;
  }
};
